import { useState, useRef } from 'react'

import { Center, Spinner, Stack } from '@chakra-ui/react'

import Modal from '../../modal'
import StyledInput from '../../styled/input'
import { useRanContext } from '../../ran-state-provider'

import { userMaintenance } from '../../../lib/api-helper'

import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../../lib/api-config'

const ChangeUsername = ({ onClose, setToast }) => {
  const { setAuthentication } = useRanContext()
  const [isLoading, setLoading] = useState(false)
  const [inputVal, setInputVal] = useState({
    oldUsername: '',
    newUsername: '',
    pin: '',
    email: '',
    password: ''
  })

  const recaptchaRef = useRef(null);

  const handleSubmit = async () => {
    if (isLoading) return
    setLoading(true)

    const captchaToken = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();

    const payload = {
        ...inputVal,
        captchaToken
    };

    const result = await userMaintenance('USERNAME', payload, setAuthentication)

    const onError = () => {
      setToast({
        status: 'error',
        messages: result?.errors?.length
          ? result.errors
          : ['Something went wrong']
      })
      setLoading(false)
    }

    if (result !== null || result !== undefined) {
      if (result.success) {
        setToast({
          status: 'success',
          messages: ['Username has been successfully updated!']
        })
        onClose()
      } else onError()
    } else onError()
  }

  return (
    <>
    <Modal
      header="CHANGE USERNAME"
      isOpen={true}
      isLoading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      {isLoading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <Stack spacing={3} w="full">
          <StyledInput
            value={inputVal?.oldUsername}
            onChange={e => setInputVal({ ...inputVal, oldUsername: e.target.value })}
            placeholder="CURRENT USERNAME"
          />
          <StyledInput
            value={inputVal?.newUsername}
            onChange={e => setInputVal({ ...inputVal, newUsername: e.target.value })}
            placeholder="NEW USERNAME"
          />
          <StyledInput
            value={inputVal?.password}
            onChange={e => setInputVal({ ...inputVal, password: e.target.value })}
            placeholder="PASSWORD"
            type="password"
          />
          <StyledInput
            value={inputVal?.pin}
            onChange={e => setInputVal({ ...inputVal, pin: e.target.value })}
            placeholder="PIN CODE"
            type="password"
          />
          <StyledInput
            value={inputVal?.email}
            onChange={e =>
              setInputVal({ ...inputVal, email: e.target.value })
            }
            placeholder="EMAIL ADDRESS"
            type="email"
          />
        </Stack>
      )}
    </Modal>
    <ReCAPTCHA
            sitekey={RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={recaptchaRef}
        />
    </>
  )
}

export default ChangeUsername
